/**
 * Role constants used throughout the application.
 * Update role values here if they change in the database.
 */

// Agency user roles (agency_users.role)
export const AGENCY_ROLES = {
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
} as const

// Company user access roles (company_user_access.role)
export const COMPANY_ROLES = {
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
} as const

// User roles (resolved from access level)
export const USER_ROLES = {
  SYSTEM_ADMIN: 'SYSTEM_ADMIN',
  AGENCY_ADMIN: 'AGENCY_ADMIN',
  COMPANY_ADMIN: 'COMPANY_ADMIN',
  MEMBER: 'MEMBER',
} as const

// Invitation roles (what can be assigned when inviting)
export const INVITE_ROLES = {
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
} as const

// All admin-level roles
export const ADMIN_ROLES = new Set([
  USER_ROLES.SYSTEM_ADMIN,
  USER_ROLES.AGENCY_ADMIN,
  USER_ROLES.COMPANY_ADMIN,
])

export type AgencyRole = (typeof AGENCY_ROLES)[keyof typeof AGENCY_ROLES]
export type CompanyRole = (typeof COMPANY_ROLES)[keyof typeof COMPANY_ROLES]
export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES]
export type InviteRole = (typeof INVITE_ROLES)[keyof typeof INVITE_ROLES]
